module.exports = __webpack_public_path__ + "img/Logo_Linkcard_Mobile.bb466ae.svg";